module.exports = __webpack_public_path__ + "img/2.ee6905f3.png";